export const GET_PLANT_SELECTION = 'Get_Plant_Selection';